import {createFileRoute} from '@tanstack/react-router';
import {z} from 'zod';

import {documentKeys} from '@/features/User/api/queryKeys';
import {getDocuments} from '@/features/User/api/readDocuments';
import {DocumentsView} from '@/features/User/components/Company/DocumentsView';
import {DEFAULT_DOCS_TOP} from '@/features/User/utils/constants';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_company/company_/documents')({
  component: DocumentsView,

  validateSearch: z.object({
    orderBy: z.string().optional(),
    filter: z.string().optional(),
    skip: z.number().catch(0),
  }),
  loaderDeps: ({search}) => ({...search}),

  beforeLoad: ({search, context}) => {
    makeDocumentTitle('Documents');

    const _deps = {...search, top: DEFAULT_DOCS_TOP};
    return {
      ...context,
      readDocumentsQuery: {
        queryKey: documentKeys.list(_deps),
        queryFn: () => getDocuments(_deps),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readDocumentsQuery);
  },
});
